export { default } from "bullitttime-embermodelsevent/models/finish-timing-record";
